module.exports = __webpack_public_path__ + "img/phone_icon.dad4315c.svg";